import React from 'react';
import { TextDetailField, TextDetailLabel } from './TextDetail.styles';
import Grid from '@mui/material/Grid2';
import PropTypes from 'prop-types';

const TextDetail = ({ label, text }) => {
	return (
		<Grid container sx={{ width: '100%' }}>
			<Grid size={12}>
				<TextDetailLabel>{label}</TextDetailLabel>
			</Grid>
			<Grid size={12}>
				<TextDetailField>{text}</TextDetailField>
			</Grid>
		</Grid>
	);
};

TextDetail.propTypes = {
	label: PropTypes.string.isRequired,
	text: PropTypes.string.isRequired,
};

export default TextDetail;
